import type { InputHTMLAttributes } from "react";
import { cn } from "../lib/utils";

export const Input = ({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) => (
  <input
    className={cn(
      "flex h-9 w-full rounded-md border px-3 py-1 text-sm shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50 brand-input brand-focus",
      className,
    )}
    {...props}
  />
);
